window.Page = {

    // All the filters
    filterMinPrice  : document.getElementById('filterMinPrice'),
    filterMaxPrice  : document.getElementById('filterMaxPrice'),
    filterDropdowns : document.querySelectorAll('.filters-dropdown'),
    sortingDropdown : document.querySelector('.sorting-dropdown'),

    // All the listings
    listingsWrap  : document.querySelector('.home-listings'),
    listings      : [...document.querySelectorAll('.listing')],
    listingActive : [],
    listingHidden : [],



    // Let's launch this thing
    liftoff : () => {
        Page.filterListings()
        Page.sortListings()
    },

    filtersShowHide : (id) => {
        Page.listingActive.forEach(listing => {listing.classList.remove(`hidden-by-${id}`)})
        Page.listingHidden.forEach(listing => {listing.classList.add(`hidden-by-${id}`)})
    },

    filtersClear : (id) => {
        Page.listings.forEach(listing => {listing.classList.remove(`hidden-by-${id}`)})
    },

    // Filter The Listings
    filterListings : () => {
        
        // If there's at least one dropdown
        if (Page.filterDropdowns) {

            // Loop and attach events to each dropdown
            Page.filterDropdowns.forEach(dropdown => {

                // Listen for a dropdown change value
                dropdown.addEventListener('change' , event => {

                    // If the value is set to null we can remove the class
                    if (dropdown.value.length === 0) {
                        Page.filtersClear(dropdown.name)
                    } else {

                    // Update the list of active listings
                    Page.listingActive = Page.listings.filter(listing => {

                        // We need to filter out differently based on the type of filter
                        if (dropdown.dataset.type == 'numeric') {
                            return Math.abs(listing.dataset[dropdown.name]) >= Math.abs(dropdown.value)
                        }

                        if (dropdown.dataset.type == 'string') {
                            return listing.dataset[dropdown.name] == dropdown.value
                        }


                    });

                    // Grab the remaining
                    Page.listingHidden = Page.listings.filter(x => !Page.listingActive.includes(x))

                    // Toggle the various classes
                    Page.filtersShowHide(dropdown.name)
                    }

                })

            })

        }

        // Filter based on price inputs
        Page.filterMinPrice.addEventListener('input' , () => {

            let value = Page.filterMinPrice.value.replace(/[^0-9]/g, '');
                value = parseInt(value,10);
                if (isNaN(value)) value = 0;

                // Update the list of active listings
                Page.listingActive = Page.listings.filter(listing => {

                    // We need to filter out differently based on the type of filter
                    return Math.abs(listing.dataset.price) >= value

                });

                // Grab the remaining
                Page.listingHidden = Page.listings.filter(x => !Page.listingActive.includes(x))

                // Toggle the various classes
                Page.filtersShowHide(Page.filterMinPrice.name)

        })

        Page.filterMaxPrice.addEventListener('input' , () => {

            let value = Page.filterMaxPrice.value.replace(/[^0-9]/g, '');
                value = parseInt(value,10);
                if (isNaN(value)) value = 99999999999999999; // We need to set a stupidly high price in order to clear the data



            // Update the list of active listings
            Page.listingActive = Page.listings.filter(listing => {

                // We need to filter out differently based on the type of filter
                return Math.abs(listing.dataset.price) <= value

            });

            // Grab the remaining
            Page.listingHidden = Page.listings.filter(x => !Page.listingActive.includes(x))

            // Toggle the various classes
            Page.filtersShowHide(Page.filterMaxPrice.name)

        })


    },

    sortListings : () => {
        Page.sortingDropdown.addEventListener('change' , event => {

            // Sort the array
            Page.listings
            .sort((a, b) => {

                if (Page.sortingDropdown.value == "date-dsc")
                    return a.dataset.updated < b.dataset.updated ? 1 : -1

                if (Page.sortingDropdown.value == "date-asc")
                    return a.dataset.updated > b.dataset.updated ? 1 : -1

                if (Page.sortingDropdown.value == "price-dsc")
                    return a.dataset.price < b.dataset.price ? 1 : -1

                if (Page.sortingDropdown.value == "price-asc")
                    return a.dataset.price > b.dataset.price ? 1 : -1

            })
            .forEach(node => Page.listingsWrap.appendChild(node));

        })
    }

};

Page.liftoff()